module.exports = __webpack_public_path__ + "static/media/tab_3_og.2c1eada4.png";